import React from 'react';
import { BaseStagePlugin } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import { SmartGuidesPlugin } from './smart-guides';
import { useSmartGuidesOperationEvents } from './snap/use-operation-events';
import smartGuidesState, { useSmartGuidesState } from './states/smart-guides-state';
import HelperView from './views/helper-view';
import './plugin.less';

/** 智能对齐 */
const SmartGuidesView: React.FC = React.memo(() => {
    useSmartGuidesOperationEvents();
    const useStore = useSmartGuidesState();
    const lines = useStore((state) => state.snapshot.lines);
    const blocks = useStore((state) => state.snapshot.blocks);

    if (!lines.length && !blocks.length) return null;

    return (
        <BaseStagePlugin name="smart-guides" zIndex={21}>
            <HelperView lines={lines} blocks={blocks} />
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 3,
    name: 'smart-guides',
    render() {
        return <SmartGuidesView />;
    },
    createState() {
        return [smartGuidesState];
    },
    createInstance({ identity }) {
        return [
            {
                key: SmartGuidesPlugin.instanceName,
                value: new SmartGuidesPlugin(identity),
            },
        ];
    },
};

export default exportPlugin;
